// Mock data for Digital Inclusion Lab website

export const ventures = [
  {
    id: 'elderra',
    title: 'Elderra',
    tagline: 'Empowering Seniors in a Digital World.',
    description: 'Elderra is a dedicated elder-tech platform designed to bridge the generational technology gap. From navigating everyday apps to providing trusted, home-based technical assistance, Elderra ensures senior citizens can participate in the digital age with confidence and dignity.',
    buttonText: 'Visit elderra.io',
    link: 'https://elderra.io',
    image: 'https://customer-assets.emergentagent.com/job_cyber-elders/artifacts/mmmf1cug_Screen%20Shot%202025-11-21%20at%201.07.59%20PM.png',
    stats: [
      { value: '1,500+', label: 'Elders Trained' },
      { value: '50+', label: 'Cities Covered' },
      { value: '0', label: 'Scams Post-Training' }
    ]
  },
  {
    id: 'project-maa',
    title: 'Project Maa',
    tagline: "A Mother's Best Friend | माँ की सबसे अच्छी दोस्त",
    description: 'Project Maa is an AI voice companion designed to support young and new mothers through their most challenging and beautiful journey. From the first signs of pregnancy to the early years of childhood, this intelligent companion is here to answer questions, calm anxieties, and guide mothers with medically-accurate, empathetic information. An initiative by Dr. Kafeel Khan.',
    buttonText: 'Meet Maa',
    link: 'https://projectmaa.in',
    image: 'https://customer-assets.emergentagent.com/job_dil-preview/artifacts/yhh7ola7_Project_Maa_Logo-removebg-preview.png',
    stats: [
      { value: '24/7', label: 'Available Support' },
      { value: 'Free', label: 'Always Free' },
      { value: '2', label: 'Expert Doctors' }
    ]
  }
];

export const mockPartnershipSubmit = (partnershipData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock partnership application submitted:', partnershipData);
      console.log('📧 Email notification sent to: gianttreefoundation26@gmail.com');
      console.log('📧 Confirmation email sent to:', partnershipData.email);
      resolve({
        success: true,
        applicationId: 'APP_' + Math.random().toString(36).substr(2, 9).toUpperCase(),
        message: 'Application received successfully!'
      });
    }, 1500);
  });
};
